import React, { useState } from 'react';
import { Dropdown, Button, Icon } from 'semantic-ui-react';

const DropdownComponent = ({ dcSweepValue, setDcSweepValue, analysisMode, setAnalysisMode, dcSweepOptions , setNodes}) => {
         
    const options = [
        { key: 'time-domain', text: l.time_domain, value: 'time_domain' },
        { key: 'dc-sweep', text: l.dc_sweep, value: 'dc_sweep' }
    ];

    const handleChange = (e, { value }) => {
        com.clientside.main.Html5Bootstrap.jsCall("setAnalysisMode", value);
        if (value != 'dc_sweep')
        setDcSweepValue('');
    
        setAnalysisMode(value);
    };

    const handleDcSweepChange = (e, { value }) => {
        com.clientside.main.Html5Bootstrap.jsCall("setDcSweepSource", value);
        setDcSweepValue(value);        
    };


    return (
        <div style={{ marginLeft: 20, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <label style={{cursor: 'move', marginRight: 10 }}>{l.analysis_type}:</label>
            <Dropdown
                placeholder={l.select_an_option}
                selection
                options={options}
                value={analysisMode}
                onChange={handleChange}
                style={{ marginRight: 20, width: 150 }} // Adjusted width for better alignment
            />
            {analysisMode === 'dc_sweep' && (
                <>
                    <label style={{cursor: 'move', marginRight: 10 }}>Sweep Target:</label>
                    <Dropdown
                        placeholder='Select sweep target'
                        selection
                        options={dcSweepOptions}
                        value={dcSweepValue}
                        onChange={handleDcSweepChange}
                        style={{ width: 150 }} // Adjusted width
                    />
                </>
            )}

            {/* Close button removed from here as it's redundant with the one in Chart.js */}
        </div>
    );
}

export default DropdownComponent;
